<kpd-secure-action-dialog key="secureDelete"></kpd-secure-action-dialog>
<div class="detail__grid">
  <div class="detail__toolbar flex-row flex-end">
    <kpd-action-bar>
      <kpd-action-edit-toggle
        [readMode]="!readOnlyMode"
        (action)="toggleViewMode()"
        [disable]="loading || (isSystemUser && !hasSystemUserManagePermission)"
        *kpdPermission="Permissions.UserLicenseUpdate"
      >
      </kpd-action-edit-toggle>
    </kpd-action-bar>
    <div class="flex-row">
      <span translate class="m-left-10">Show expired</span>
      <kpd-toggle class="toggle m-left-5" [(ngModel)]="showExpired"></kpd-toggle>
    </div>
  </div>
  <div class="detail__main">
    <kpd-entity-not-assigned
      icon="key"
      [header]="'No licenses assigned' | translate"
      [description]="'Edit this user to assign them available licenses.' | translate"
      *ngIf="!loading && licenses.length === 0 && readOnlyMode"
    ></kpd-entity-not-assigned>
    <div class="overview__header flex-row flex-align-items-center" *ngIf="licenses.length > 0">
      <kpd-search
        [config]="searchConfig"
        [itemTotal]="(itemsTotalCount || 0) + ' ' + ('Results' | translate)"
        [placeholder]="'Search...' | translate"
        [searchExpression]="searchExpression"
        (updated)="onSearch($event)"
      ></kpd-search>
    </div>
    <div *ngFor="let license of activeLicenses" class="licenses m-left-10 m-top-10">
      <app-license-card
        [license]="license.license"
        [loading]="license.loading"
        (onClickAssigned)="onClickAssigned(license.license.key)"
      >
        <div class="license__toggle">
          <kpd-toggle
            class="toggle"
            [(ngModel)]="license.hasLicense"
            [disabled]="
              license.license.isExpired ||
              license.license.isOutofbounds ||
              (license.license.isInvalid && !license.license.isFuture) ||
              (!license.hasLicense && license.license.quantityAvailable === 0)
            "
            [loading]="license.loading"
            *ngIf="!readOnlyMode"
            (change)="onToggle(license)"
          ></kpd-toggle>
        </div>
        <div class="license__error" *ngIf="license.error">
          <clr-icon class="form2__error-icon" shape="error-standard"></clr-icon>
          <div class="form2__error-message">
            {{ license.error }}
          </div>
        </div>
      </app-license-card>
    </div>
    <div *ngIf="showExpired" class="m-left-10 m-top-10">
      <p translate *ngIf="expiredLicenses.length > 0">Expired licenses</p>
      <div *ngFor="let license of expiredLicenses" class="licenses m-top-10">
        <app-license-card
          [license]="license.license"
          [loading]="license.loading"
          (onClickAssigned)="onClickAssigned(license.license.key)"
        >
          <div class="license__toggle">
            <kpd-toggle
              class="toggle"
              [(ngModel)]="license.hasLicense"
              [disabled]="
                license.license.isExpired ||
                license.license.isOutofbounds ||
                (license.license.isInvalid && !license.license.isFuture) ||
                (!license.hasLicense && license.license.quantityAvailable === 0)
              "
              [loading]="license.loading"
              *ngIf="!readOnlyMode"
              (change)="onToggle(license)"
            ></kpd-toggle>
          </div>
          <div class="license__error" *ngIf="license.error">
            <clr-icon class="form2__error-icon" shape="error-standard"></clr-icon>
            <div class="form2__error-message">
              {{ license.error }}
            </div>
          </div>
        </app-license-card>
      </div>
    </div>
  </div>
</div>
